import { FormControl, MenuItem, Stack } from '@mui/material';
import RoundedSelect from 'common/components/RoundedSelect';
import SearchInput from 'common/features/filters/components/SearchInput';
import useFlexBoxStyles from 'common/flexBox';
import { useTranslation } from 'react-i18next';

const EventFormSelectAssetsFilter = (props) => {
    const { type, setSearch, setType, typesSelect, searchMinLength } = props;

    const { t } = useTranslation();
    const { classes: flexBox, cx } = useFlexBoxStyles();

    const handleSearchChange = (e) => {
        setSearch(e);
    };

    return (
        <Stack direction="row" spacing={2} className={flexBox.paddingBottom3}>
            {Boolean(typesSelect) && (
                <FormControl className={cx(flexBox.w100)}>
                    <RoundedSelect value={type} onChange={(e) => setType(e.target.value)} size={'big'} fullWidth={true}>
                        {typesSelect.map((type) => (
                            <MenuItem key={type.name} value={type.value}>
                                {t(type.name)}
                            </MenuItem>
                        ))}
                    </RoundedSelect>
                </FormControl>
            )}
            <SearchInput
                searchMinLength={searchMinLength}
                onChange={handleSearchChange}
                onClick={() => {}}
                fullWidth={true}
            />
        </Stack>
    );
};

export default EventFormSelectAssetsFilter;
